export default () => ({
  item: {},
  dialog: false,
});
